import {
  IQuoteServiceVariableActions,
  QuoteServiceVariableContext
} from './actions.types';
import { IQuoteServiceVariableData } from '@/models';

export const actions: IQuoteServiceVariableActions = {
  fetchQuoteServiceVariables(
    context: QuoteServiceVariableContext
  ): Promise<void> {
    return this.$services.quoteServiceVariable
      .fetchQuoteServiceVariables()
      .then((variables: IQuoteServiceVariableData[]) => {
        context.commit('SET_QUOTE_SERVICE_VARIABLES', variables);
      });
  },

  fetchQuoteServiceVariable(
    context: QuoteServiceVariableContext,
    payload: number
  ): Promise<void> {
    return this.$services.quoteServiceVariable
      .fetchQuoteServiceVariable(payload)
      .then((variable: IQuoteServiceVariableData) => {
        const index = context.state.quoteServiceVariables.findIndex(
          (v: IQuoteServiceVariableData) => v.id === variable.id
        );
        if (index === -1) {
          context.commit('ADD_QUOTE_SERVICE_VARIABLE', variable);
        } else {
          context.commit('UPDATE_QUOTE_SERVICE_VARIABLE', variable);
        }
      });
  },

  createQuoteServiceVariable(
    context: QuoteServiceVariableContext,
    payload: IQuoteServiceVariableData
  ): Promise<void> {
    return this.$services.quoteServiceVariable
      .createQuoteServiceVariable(payload)
      .then((variable: IQuoteServiceVariableData) =>
        context.commit('ADD_QUOTE_SERVICE_VARIABLE', variable)
      );
  },

  updateQuoteServiceVariable(
    context: QuoteServiceVariableContext,
    payload: IQuoteServiceVariableData
  ): Promise<void> {
    return this.$services.quoteServiceVariable
      .updateQuoteServiceVariable(payload)
      .then((variable: IQuoteServiceVariableData) => {
        const index = context.state.quoteServiceVariables.findIndex(
          (v: IQuoteServiceVariableData) => v.id === variable.id
        );
        if (index === -1) {
          context.commit('ADD_QUOTE_SERVICE_VARIABLE', variable);
        } else {
          context.commit('UPDATE_QUOTE_SERVICE_VARIABLE', variable);
        }
      });
  },

  deleteQuoteServiceVariable(
    context: QuoteServiceVariableContext,
    payload: number
  ): Promise<void> {
    return this.$services.quoteServiceVariable
      .deleteQuoteServiceVariable(payload)
      .then(() => {
        context.commit('REMOVE_QUOTE_SERVICE_VARIABLE', payload);
      });
  }
};
